import { useState } from "react";
import {
  Setup,
  Magnifier,
  Awareness,
  GentleReturn,
  TimeWeight,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { CardDetailsModal } from "@components/ui/CardDetailsModal";

const MindFulnessCardView = ({
  dashboard = false,
  mindfulnessStepsData = {},
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const handleOpen = ({
    label = null,
    icon = null,
    value = null,
    tabColor = null,
    model_value = null,
  }) => {
    setData({
      label,
      icon,
      value,
      tabColor,
      model_value,
    });
    setOpen(true);
  };
  const nutrientData = [
    {
      label: t("Setup"),
      key: "setup",
      icon: <Setup className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.setup,
      model_value: mindfulnessStepsData?.setup_detail
        ? mindfulnessStepsData?.setup_detail
        : mindfulnessStepsData?.setup,
    },
    {
      label: t("Focus"),
      key: "focus",
      icon: <Magnifier className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.focus,
      model_value: mindfulnessStepsData?.focus_detail
        ? mindfulnessStepsData?.focus_detail
        : mindfulnessStepsData?.focus,
    },
    {
      label: t("Awareness"),
      key: "awareness",
      icon: <Awareness className="min-w-7 min-h-7" />,
      tabColor: "#F0FFFF",
      value: mindfulnessStepsData?.awareness,
      model_value: mindfulnessStepsData?.awareness_detail
        ? mindfulnessStepsData?.awareness_detail
        : mindfulnessStepsData?.awareness,
    },
    {
      label: t("Gentle Return"),
      key: "gentle_return",
      icon: <GentleReturn className="min-w-7 min-h-7" />,
      tabColor: "#FFF0FB",
      value: mindfulnessStepsData?.gentle_return,
      model_value: mindfulnessStepsData?.gentle_return_detail
        ? mindfulnessStepsData?.gentle_return_detail
        : mindfulnessStepsData?.gentle_return,
    },
    {
      label: t("Duration"),
      key: "duration",
      icon: <TimeWeight className="min-w-7 min-h-7" />,
      tabColor: "#FFF0FF",
      value: mindfulnessStepsData?.duration,
      model_value: mindfulnessStepsData?.duration_detail
        ? mindfulnessStepsData?.duration_detail
        : mindfulnessStepsData?.duration,
    },
  ];

  const Card = ({ label, icon, value, tabColor, model_value }) => (
    <div
      className="cursor-pointer transition-all duration-200 hover:scale-105 py-5 px-2 rounded-[17px] bg-white border border-[#E6E6E6] flex md:items-center xl:items-start xl:justify-start flex-row md:flex-col xl:flex-row md:justify-center gap-2 overflow-hidden"
      style={{
        boxShadow: "7px 7px 9.5px 0px #0000000D",
      }}
      onClick={() => handleOpen({ label, icon, value, tabColor, model_value })}
    >
      <div className="flex justify-center">
        <div
          className="rounded-full min-w-11 min-h-11 max-w-11 max-h-11 flex items-center justify-center"
          style={{
            backgroundColor: tabColor,
          }}
        >
          {icon}
        </div>
      </div>
      <div>
        <p className="text-[16px] font-[500] text-[#6C6A6ACC] md:text-center xl:text-start">
          {label}
        </p>
        <div>
          <p
            className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#6C6A6A] md:text-center xl:text-start"
            style={{
              wordBreak: "break-word",
              hyphens: "auto",
              overflowWrap: "break-word",
            }}
          >
            {value}...
            <span
          // onClick={() =>
          //   handleOpen({ label, icon, value, tabColor, model_value })
          // }
          className="cursor-pointer mt-2 text-[12px] text-[#15AAFC] font-[Lato] font-[500]"
        >
        SEE MORE
        </span>
          </p>
        </div>
        {/* <span
          onClick={() =>
            handleOpen({ label, icon, value, tabColor, model_value })
          }
          className="absolute left-4 bottom-3 cursor-pointer mt-2 text-[12px] text-[#4A90E2] underline underline-offset-2 font-medium"
        >
          Learn more →
        </span> */}
      </div>
    </div>
  );

  // Original layout (non-dashboard)
  return (
    <div className="p-6 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-lg mt-6">
      {/* First Row - 3 cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-3">
        {nutrientData
          .slice(0, 3)
          .map(({ label, icon, value, tabColor, model_value }, index) => (
            <Card
              key={index}
              label={label}
              icon={icon}
              value={value}
              tabColor={tabColor}
              model_value={model_value}
            />
          ))}
      </div>

      {/* Second Row - 2 cards centered */}
      <div className="flex justify-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl">
          {nutrientData
            .slice(3)
            .map(({ label, icon, value, tabColor, model_value }, index) => (
              <Card
                key={index + 3}
                label={label}
                icon={icon}
                value={value}
                tabColor={tabColor}
                model_value={model_value}
              />
            ))}
        </div>
      </div>
      <CardDetailsModal open={open} setOpen={setOpen} data={data} />
    </div>
  );
};

export default MindFulnessCardView;
